import { default as AbstractModal } from './AbstractModal'

export default class ModalVideo extends AbstractModal {

    constructor(m) {
        super(m)

        // DOM
        this.$el = this.el
        this.$image = this.$('image')[0]
        this.$title = this.$('title')[0]
        this.$position = this.$('position')[0]
        this.$tags = this.$('tags')[0]
        this.$content = this.$('content')[0]

        // Variables
        this.MEMBERS = JSON.parse(this.getData('json'))

        // Events
        this.events = {
            click: {
                'close': 'close',
            },
        }

    }

    onOpen(id=null) {
        const data = this.MEMBERS.find(m => m.id === id)

        if(typeof data === 'undefined') {
            return
        }

        // Set image with all attributes (src, alt, width, height)
        const image = data.image
        if(typeof image.src !== 'undefined') {
            for (let i in image) {
                this.$image.setAttribute(i, image[i])
            }
        }

        // Set tags
        for (let tag of data.categories) {
            this.$tags.innerHTML += `
                <li class="o-tag-list_item">
                    <span class="o-tag | o-text-small">
                        ${tag.title}
                    </span>
                </li>
            `
        }

        this.$title.innerHTML = data.title
        this.$position.innerHTML = data.position
        this.$content.innerHTML = data.content
    }

    onClose() {
        this.$image.src = ''
        this.$title.innerHTML = ''
        this.$position.innerHTML = ''
        this.$tags.innerHTML = ''
        this.$content.innerHTML = ''
    }
}
